module.exports = {"445222001":"河婆街道","445222102":"龙潭镇","445222103":"南山镇","445222104":"五经富镇","445222105":"京溪园镇","445222106":"灰寨镇","445222107":"塔头镇","445222108":"东园镇","445222109":"凤江镇","445222110":"棉湖镇","445222111":"金和镇","445222112":"大溪镇","445222113":"钱坑镇","445222114":"坪上镇","445222115":"五云镇","445222116":"上砂镇","445222201":"良田乡","445222401":"北山农林场","445222402":"果林场","445222403":"油桐林场","445222404":"高田农场","445222405":"河輋农场","445222406":"县苗圃场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445222.json
// module id = 2061
// module chunks = 0